<template>
  <div class="sole-good-billion" @click="goDetail">
    <good-image
      :img-url="ssu.skuImg.imgUrl"
      :image-width="72"
      :stock-status="stockStatus"
      :custom-style="customImagStyle"
      :left-upper-tag="leftUpperTag"
      :sku-img="skuImg"
    />
    <div class="info">
      <base-info
        single-name
        :custom-style="baseInfoStyle"
        :name="ssu.skuBase.skuName"
      />
      <good-price-billion
        :ssu="ssu"
        :ssu-info="ssuInfo"
        :custom-operator="customOperator"
        :custom-style="customPriceStyle"
        show-original-price
        :show-price-line="!!extraTag"
        :billion-tip="extraTag"
        @goDetail="goDetail"
      />
    </div>
  </div>
</template>

<script>
import mixin from '../newMixin'
// import {
//   THEME_START_COLOR,
//   THEME_ENG_COLOR,
//   THEME_COLOR
// } from '@/defines/environment/config'

export default {
  name: 'NewSoleGoodBillon',
  mixins: [mixin],
  data() {
    return {
      customOperator: {
        simple: false,
        showPromoteTip: true,
        type: 'large',
        btnWith: 1.6,
        bgStartColor: '#FF790B',
        bgEndColor: '#FF4636',
        iconColor: '#FF4635'
      },
      baseInfoStyle: {
        name: {
          fontSize: '0.28rem',
          'text-overflow': 'ellipsis',
          overflow: 'hidden',
          'white-space': 'nowrap',
          'margin-top': '0px',
          'margin-bottom': '0.08rem'
        }
      },
      customPriceStyle: {
        unitPrice: {
          fontSize: '0.24rem',
          color: '#262626'
        },
        ssuFpText: {
          fontSize: '0.22rem'
        },
        billionPrice: {
          fontSize: '.44rem'
        }
      },
      customImagStyle: {
        width: '1rem',
        height: '1rem',
        leftUpperTag: {
          top: '0.04rem',
          left: '0.04rem'
        },
        goodImage: {
          borderRadius: '0.08rem',
          overflow: 'hidden'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sole-good-billion {
  width: 100%;
  padding: 0.24rem 0.16rem;
  overflow: hidden;

  background-color: #fff;
  border-radius: 0.16rem;

  flex: none;
  box-sizing: border-box;
  @include flex(row, flex-start, flex-start, nowrap);

  .info {
    position: relative;

    margin-left: 0.16rem;
    overflow: hidden;

    flex: auto;
  }
}
</style>
